import React, { ChangeEvent, ComponentType, FC } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import { ITimeInputProps, TimeInput } from 'transfix-ui'

type IBaseControllerProps = ControllerProps<ComponentType<ITimeInputProps>>

export interface IControlledTimeInputProps
  extends Pick<
    IBaseControllerProps,
    'control' | 'name' | 'defaultValue' | 'label' | 'required' | 'className'
  > {
  TimeInputProps?: Omit<ITimeInputProps, 'onChange' | 'value'> & {
    dataTest?: string
  }
  onChange?: (time: string) => void
}

export const ControlledTimeInput: FC<IControlledTimeInputProps> = ({
  TimeInputProps,
  className,
  control,
  defaultValue,
  name,
  onChange: onTimeChange,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ onChange, value }) => {
        const changeHandler = (change: ChangeEvent<HTMLInputElement>) => {
          const {
            target: { value },
          } = change
          onChange(value)
          if (onTimeChange) {
            onTimeChange(value)
          }
        }

        return (
          <TimeInput
            className={className}
            onChange={changeHandler}
            value={value}
            {...TimeInputProps}
          />
        )
      }}
    />
  )
}

export default ControlledTimeInput
